// ./src/hooks/useCreateInPlace.ts
//
// ROADMAP A2h #142 — the ONE answer to "may this picker offer Add new here?": the person may create this kind of record
// in the account it will belong to (`mayCreateInPlace` — the owner always, crew only with the server's capability, and
// never into a crew member's own account), AND that account's plan includes the feature, when the create is a gated
// one (`useFeatureGate` — the event account's plan in its workspace).
import { useMemo } from "react";

import { useCrewAccess } from "@/contexts/CrewAccessContext/CrewAccessContext";
import { CreateInPlaceRule, mayCreateInPlace } from "@/utils/createInPlace";

import { useFeatureGate } from "./useFeatureGate";

export const useCreateInPlace = (
  rule: CreateInPlaceRule,
  /** The feature the server's create gate checks, when it has one (`planFeatureGate`). */
  featureCode?: string | null,
  /** The event the record is created under, when there is one. */
  eventId?: string | null,
): boolean => {
  const access = useCrewAccess();
  const { checkFeature } = useFeatureGate();

  return useMemo(
    () => mayCreateInPlace(rule, access) && (!featureCode || checkFeature(featureCode, { eventId }).allowed),
    [rule, access, featureCode, checkFeature, eventId],
  );
};
